import $ from 'jquery';
import Reflux from 'reflux';
const ContentCache = {};


const IsiActions = Reflux.createActions({
   'toggle': {},
   'linkClick': {},
   'toggleAutoScroll':{},
   'toggleSticky': {},
   'accept':{},
   'getContent':{
        children: ['completed', 'failed']
    }
});

IsiActions.getContent.listen(function(path) {
    if (ContentCache[path]) {
      this.completed(ContentCache[path])
      return;
    }
    const doSuccess = function(data){
      ContentCache[path] = data;
      this.completed(ContentCache[path])
    }
    const doError = function(response){
      this.failed(response);
    }

    let baseURL = window.medscape.config.appServer.host+window.medscape.config.appServer.path
    if(window.medscape.config.env=="localhost"){
        baseURL +="/build/localhost/app";
    }

    let url = `${baseURL}${path}`;
    if(window.medscape.config.env=="localhost"){
        url +=".jsp";
    }
    $.ajax({
      type: 'get',
      url: url,
      data: {},
      dataType: 'html',
      cache: false
    }).then(doSuccess.bind(this), doError.bind(this));

});

export default IsiActions;


// WEBPACK FOOTER //
// ./src/app/isi/actions.js